function beltRightDown(){
    this.main;
}
beltRightDown.prototype={
    "init":function(){
        
        this.main=$("#mainBeltRightDownCorner");
        this.update();
    },
    "update":function(){
        if(this.main.find("#mainEmailConf").length){
            return false;
        }
        var bonus=_myProfile.takeBonusTime();
        var obj=this.main.find(".mainObj[data-type='bonus']");
        var q_id=getQuestId(),q_arr=[-1,21,22];
        if(bonus.type!="" && in_array(q_id,q_arr)){
           var conf=bonus[bonus.type];
           obj.show();
           obj.attr({"data-color":conf.color,"action":conf.action});
           obj.find(".val").html(conf.bonus_show+"%");
           obj.find(".imgMain").css("background-image","url("+conf.img+")");
           //data-type="bonus"
           
           return true;
        }
        else{
            obj.hide();
        }
        return true;
    },
};
_beltRightDown= new beltRightDown();
